import { useModal } from "@/Contexts";
import { Button } from "@/components/button/index";
import { Card, CardComponentVariant } from "@/components/pageCards/card";
import { DeleteTenantModal } from "@/pages/customer/manage/components/DeleteTenant";

import { FC } from "react";

interface CustomerAdminCardProps {
  customerId: string;
  customerName?: string;
}

export const CustomerAdminCard: FC<CustomerAdminCardProps> = ({
  customerId,
  customerName = "",
}) => {
  const { showModal } = useModal();

  const openDeletionModal = () => {
    showModal(<DeleteTenantModal {...{ customerId, customerName }} />);
  };

  return (
    <Card title={"drawerLabels:admin"} variant={CardComponentVariant.DRAWER}>
      <Button
        label={"actions:deleteCustomer"}
        color="black"
        className="float-right"
        onClick={openDeletionModal}
      />
    </Card>
  );
};
